import React, { PropTypes } from 'react';
import GenericPageLayout from '../generic-page-layout';
import { compTypeInfo } from './company-type-text';
import CompanyTypeTable from './company-type-table';

const SelectCompanyTypeContainer = props => {
  const {
    companyTypeChecked,
    checkOneCompanyType,
    uncheckOneCompanyType,
    dispatchedUpdateProps,
    selectedCompanyType,
    goToAcctCreactionReason,
  } = props;

  const tableBody = compTypeInfo.map((companyType, index) => {
    return (
      <CompanyTypeTable
        key={index}
        companyTypeChecked={companyTypeChecked}
        checkOneCompanyType={checkOneCompanyType}
        uncheckOneCompanyType={uncheckOneCompanyType}
        selectedCompanyType={selectedCompanyType}
        dispatchedUpdateProps={dispatchedUpdateProps}
        {...companyType}
      />
    );
  });

  return (
    <GenericPageLayout
      title={'Welcome to TourConnect'}
      pageDesc={'In order to give you the best experience, please start by telling us a little bit about your company.'}
      boldedTableDesc={'What does your company do?'}
      dispatchedUpdateProps={dispatchedUpdateProps}
      hideIndicatorDots
      tableInfo={tableBody}
      onNextClick={goToAcctCreactionReason}
      nextButtonDisabled={companyTypeChecked.length < 1}
      footer={
        <p style={{ margin: '0 auto', fontSize: '14px', color: 'rgba(0, 0, 0, 0.87)', width: '55%', display: 'block' }}>
          * If you're not sure what to choose, please click <a href="mailto:support@tourconnect.com?subject=Help Selecting Company Type">here</a> to contact our support team.
        </p>
      }
    />
  );
};

SelectCompanyTypeContainer.propTypes = {
  checkOneCompanyType: PropTypes.func,
  uncheckOneCompanyType: PropTypes.func,
  companyTypeChecked: PropTypes.array,
  dispatchedUpdateProps: PropTypes.func,
  selectedCompanyType: PropTypes.string,
  goToAcctCreactionReason: PropTypes.func,
};

export default SelectCompanyTypeContainer;



// WEBPACK FOOTER //
// ./src/app/components/signup/select-company-type/select-company-type-container.jsx